import { styled } from "@mui/material";
import { DatePicker as MuiDatePickerPro } from "@mui/x-date-pickers-pro";
import { calendarPickerStyle } from "../DateTimePickers.style";

/** @deprecated use Inputs/DatePicker instead */
export const DatePicker = styled(MuiDatePickerPro)(calendarPickerStyle) as typeof MuiDatePickerPro;

export default DatePicker;
